<template>
  <div>
    <DataTable
      :value="steps"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :filters="filters"
      :loading="loading"
      sortField="stepNo"
      :sortOrder="1"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} steps"
    >
      <template #empty> No follow-up steps found. </template>
      <template #loading> Loading follow-up steps. Please wait. </template>
      <Column field="stepNo" header="Step" headerStyle="width: 5em" :sortable="true" />
      <Column field="daysAfterEnrolment" header="Days after enrolment" headerStyle="width: 10em" :sortable="true" />
      <Column field="subjectTemplate" header="Subject" :sortable="true" />
      <Column field="active" header="Is Active" headerStyle="width: 7em" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 8em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-info"
              class="p-button-success p-mb-2"
              @click="$emit('edit-step', slotProps.data)"
              :model="getButtons(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: ['steps', 'loading'],
  data: () => ({
    filters: { global: '' }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.$emit('delete-step', data)
          }
        })
      }
      return buttons
    }
  }
}
</script>

<style></style>
